export enum InvoicesRoutesEnum{
    PREFIX             = 'INVOICES',
    INVOICES_LIST      = 'INVOICES_LIST',
}